import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  clubName: "",
  idClub: "",
  idService: [],
  dateListArr: [],
  countClasses: 0,
  checkFilial: -1,
};

const clubsSlice = createSlice({
  name: "clubs",
  initialState,
  reducers: {
    setFilialType(state, action) {
      state.clubName = action.payload;
    },
    setIdFilial(state, action) {
      state.idClub = action.payload;
    },

    pushIdServices(state, action) {
      state.idService.push(action.payload);
    },
    clearIdServices(state) {
      state.idService = [];
    },

    pushDateArr(state, action) {
      state.dateListArr.push(action.payload);
    },
    clearDateArr(state) {
      state.dateListArr = [];
    },
    setClassesCount(state, action) {
      state.countClasses = action.payload;
    },
    checkFilial(state, action) {
      state.checkFilial = action.payload;
    },
  },
});

export const {
  setFilialType,
  setIdFilial,
  pushIdServices,
  clearIdServices,
  pushDateArr,
  clearDateArr,
  setClassesCount,
  checkFilial,
} = clubsSlice.actions;
export default clubsSlice.reducer;
